import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CreateVisumComponent } from './create-visum.component';
import { MatTableModule } from '@angular/material/table';
import { ToggleMenuButtonModule } from '../toggle-menu-button/toggle-menu-button.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatRowKeyboardSelectionModule } from '../../core/directive/mat-row-keyboard-selection.module';
import { MatLineModule, MatRippleModule } from '@angular/material/core';
import { DateRangeSelectionModule } from '../date-range-selection/date-range-selection.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { HelpManualOpenModule } from '../../core/directive/help-manual-open.module';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [CreateVisumComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatTableModule,
    TranslateModule.forChild({}),
    MatRippleModule,
    MatRowKeyboardSelectionModule,
    ToggleMenuButtonModule,
    DateRangeSelectionModule,
    MatLineModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    HelpManualOpenModule,
    MatCheckboxModule,
    FormsModule,
  ],
  exports: [CreateVisumComponent],
  providers: [],
})
export class CreateVisumModule {}
